module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/abdomen-fa996fec62b526f4244f463b17e5269e.png";